import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
  { label: "Categories", href: "#categories" },
  { label: "Sourcing", href: "#why" },
  { label: "Inquiry", href: "#inquiry" },
  { label: "Network", href: "#network" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FAF8F4]/95 border-b border-border/60 shadow-sm"
          : "backdrop-blur-md bg-[#FAF8F4]/80 border-b border-border/30"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] md:h-[84px] grid grid-cols-[1fr_auto] md:grid-cols-3 items-center gap-4">
        <a href="/" className="flex items-center group justify-self-start min-w-0">
          <Logo className="h-12 sm:h-14 md:h-[60px] lg:h-[72px] w-auto max-w-none transition-opacity group-hover:opacity-90" />
        </a>

        <nav className="hidden md:flex items-center justify-center gap-6 lg:gap-10">
          {LINKS.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-sm font-medium text-muted hover:text-primary link-underline transition-colors whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center justify-self-end gap-2">
          <a href="#inquiry" className="hidden md:inline-flex btn-gold !py-2.5 !px-5 text-sm whitespace-nowrap">
            Get a Quote
          </a>
          <button
            type="button"
            className="md:hidden p-2 text-primary"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            aria-expanded={open}
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border/60 bg-[#FAF8F4]/95 backdrop-blur-xl animate-[slideDown_0.3s_ease]">
          <nav className="px-6 py-6 flex flex-col gap-1">
            {LINKS.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className="py-3 text-base font-medium text-primary border-b border-border/40 last:border-b-0"
              >
                {item.label}
              </a>
            ))}
            <a href="#inquiry" onClick={() => setOpen(false)} className="btn-gold w-full justify-center mt-4">
              Get a Quote
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
